const comments = [
  {
    name: '影迷小李',
    time: '2小时前',
    movie: '星际迷航：新纪元',
    text: '无极电影网的蓝光画质真的太震撼了！在家用大屏看完全不输影院效果，而且播放超流畅，一点卡顿都没有。强烈推荐给所有科幻迷！',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20circle%20with%20soft%20gradient%20from%20golden%20amber%20to%20warm%20brown%2C%20minimalist%20style%2C%20no%20text%20no%20faces&width=80&height=80&seq=avatar-comment-01&orientation=squarish',
  },
  {
    name: '电影控阿杰',
    time: '5小时前',
    movie: '夜雨江湖',
    text: '找了好久这部老片的修复版，终于在这里看到了！4K修复后画面质感提升了不止一个档次，感谢无极电影网的精心挑选。',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20circle%20with%20soft%20gradient%20from%20crimson%20red%20to%20dark%20burgundy%2C%20minimalist%20style%2C%20no%20text%20no%20faces&width=80&height=80&seq=avatar-comment-02&orientation=squarish',
  },
  {
    name: '周末观影人',
    time: '昨天',
    movie: '深海迷城',
    text: '院线刚上映的片子这里就能看了，画质还这么高清，真的惊到我了。而且完全没有烦人的广告弹窗，观影体验一级棒！',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20circle%20with%20soft%20gradient%20from%20warm%20copper%20to%20dark%20bronze%2C%20minimalist%20style%2C%20no%20text%20no%20faces&width=80&height=80&seq=avatar-comment-03&orientation=squarish',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 border border-secondary-200 mb-4">
            <i className="ri-chat-quote-line text-secondary-600 text-sm"></i>
            <span className="text-xs font-medium text-secondary-700 whitespace-nowrap">真实反馈</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">
            影迷热评
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-200 max-w-lg mx-auto">
            看看其他影迷怎么说，发现更多值得看的好电影
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-6 border border-background-200/60"
            >
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 md:w-12 md:h-12 flex-shrink-0 rounded-full overflow-hidden bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-50 whitespace-nowrap">
                    {comment.name}
                  </h3>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className="text-xs text-foreground-300">{comment.time}</span>
                    <span className="text-xs px-1.5 py-0.5 rounded bg-primary-100 text-primary-700 whitespace-nowrap">
                      {comment.movie}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex text-accent-400 gap-0.5 mb-3">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-xs"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-100 leading-relaxed">
                "{comment.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}